import React from 'react';
import photo from '../../assets/img/examplePhoto.png';
import { useSelector } from 'react-redux';
import phoneBackground from '../../assets/img/phoneBackground.jpeg'
const monthNames = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
];
const dayNames = [
  "Pazar", "Pazartesi", "Salı", "Çarşamba",
  "Perşembe", "Cuma", "Cumartesi"
];
const MarketingPhone = ({ notificationHeader, notificationDescription, popupData }) => {
  const myAppsData = useSelector((state) => state.myAppsSlice.localReduxData)

  const app = myAppsData?.app
  const time = new Date()
  const hours = time.getHours() < 10 ? "0" + time.getHours() : time.getHours()
  const minutes = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()
  const day = time.getDate()
  const currentMonthIndex = new Date().getMonth();
  const currentDayIndex = time.getDay();

  // Get the current day name
  const currentDayName = dayNames[currentDayIndex];

  // Get the current month name
  const currentMonthName = monthNames[currentMonthIndex];


  return (
    <div class="w-full flex justify-center p-10">
      <div class=" h-[37rem] bg-gradient-to-b from-black to-black border border-black rounded-[3rem] flex items-center justify-center border-box p-[0.2rem] relative shadow-[1rem_1rem_6rem_rgba(0,0,0,0.4),0_0_0.1rem_rgba(0,0,0,0.4)]">
        <div class="w-1 h-20 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-r from-neutral-400 via-black to-black border-r border-black absolute -right-1 top-[30%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>
        <div class="w-1 h-10 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-l from-neutral-400 via-black to-black border-l border-black absolute -left-1 top-[38%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>
        <div class="w-1 h-10 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-l from-neutral-400 via-black to-black border-l border-black absolute -left-1 top-[28%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>
        <div class="w-1 h-5 rounded-[0_0.1rem_0.1rem_0] bg-gradient-to-l from-neutral-400 via-black to-black border-l border-black absolute -left-1 top-[20%] shadow-[2px_0_1px_rgba(0,0,0,0.2)_inset]"></div>

        <div class="h-full w-full bg-black rounded-[2.9rem] flex items-center justify-center border-box p-[0.5rem] relative overflow-hidden">
          <div class="h-full  bg-cover bg-center rounded-[2.4rem] flex items-center flex-col relative !w-[272.58px]" style={{ backgroundImage: "url(" + phoneBackground + ")" }}>
            {!popupData &&
              <div class="w-full  flex flex-col items-center">
                <div class="w-[5rem] h-[1.4rem] bg-black mt-[0.5rem] rounded-full"></div>
                <span class="font-[Inter] opacity-60 text-white font-normal text-md mt-8">{day} {currentMonthName}, {currentDayName} </span>
                <span class="font-[Inter] opacity-60 text-white font-bold text-7xl mt-2 tracking-tighter">{hours}:{minutes}</span>
              </div>

            }
            {popupData ?
              <div className='absolute w-full h-full left-[0] top-0 p-[6px] rounded-[2.4rem] overflow-hidden flex items-center justify-center'>
                <div className='shadow !absolute !w-full !h-full'></div>
                <div className='bg-white p-[6px] rounded-md z-[501] relative w-full'>
                  <div className='m-auto'>
                    <img className='rounded-md' src={popupData?.image} />
                    <div className='text-center my-[6px]' style={{ fontWeight: 700, fontSize: popupData?.popupHeaderTextSize, color: popupData?.popupHeaderTextColor }}>{popupData?.popupHeaderText}</div>
                    <div className='text-center my-[6px]' style={{ fontWeight: 500, fontSize: popupData?.popupContentTextSize, color: popupData?.popupContentTextColor }}>{popupData?.popupContentText}</div>
                    <div className='flex flex-row gap-[5px] mt-[6px]'>
                      <div className='rounded-md flex-1 border-1 flex items-center justify-center items-center text-center px-[6px] py-[8px]' style={{
                        fontWeight: popupData?.leftButtonFontWeight,
                        fontSize: popupData?.leftButtonTextSize,
                        color: popupData?.leftButtonText,
                        backgroundColor: popupData?.leftButtonBackgroundColor,
                        borderColor: popupData?.leftButtonBorderColor,

                      }}>{popupData?.leftButtonText}</div>
                      <div className='rounded-md flex-1 border-1 flex items-center justify-center items-center text-center px-[4px] py-[8px]' style={{
                        fontWeight: popupData?.rightButtonfontWeight,
                        fontSize: popupData?.rightButtonTextSize,
                        color: popupData?.rightButtonText,
                        backgroundColor: popupData?.rightButtonBackgroundColor,
                        borderColor: popupData?.rightButtonBorderColor,

                      }}>{popupData?.rightButtonText}</div>
                    </div>
                  </div>
                </div>

              </div> :
              <>
                <div className='backdrop-blur-xl	backdrop-brightness-150 w-[93%] mx-auto rounded-[20px] px-5 py-3'>
                  <div className='flex flex-row w-full gap-[10px] '>
                    <img className='w-[30px] h-[30px] my-auto rounded-md' src={app?.appLogo}></img>
                    <div className=' min-w-[0px]'>
                      <div className='font-semibold text-white text-[9.99px] truncate'>
                        {notificationHeader?.split("\n")?.map((line, index) => (
                          <div className='truncate' key={index}>{line}</div>
                        ))}</div>
                      <div className='text  text-white text-[9.75px] text-normal w-full break-words'>
                        {notificationDescription?.split("\n")?.map((line, index) => (
                          <div key={index}>{line}</div>
                        ))}
                      </div>

                    </div>
                  </div>

                </div>
                <div class="w-full flex flex-col items-center mt-auto">
                  <span class="text-white opacity-60 mb-2 text-xs">Swipe up to unlock</span>
                  <div class="bg-white opacity-60 w-[5rem] h-[0.2rem] bg-black mb-8 rounded-full"></div>
                </div>
              </>
            }
          </div>

        </div>

      </div>
    </div>
  )
}

export default MarketingPhone